import FeedSlideOne from "src/assets/images/feed-images/img-one.png";
import FeedSlideTwo from "src/assets/images/feed-images/img-two.png";

export const init_categories = [
  {
    Categoryid: -3,
    CategoryName: "Feed",
    Discription: "",
  },
  {
    Categoryid: -1,
    CategoryName: "Today",
    Discription: "",
  },
  {
    Categoryid: -2,
    CategoryName: "Tomorrow",
    Discription: "",
  },
];

export const feed_data = [FeedSlideOne, FeedSlideTwo];
